var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00037 2.53846C2.42521 2.53846 2.7696 2.19407 2.7696 1.76923C2.7696 1.3444 2.42521 1 2.00037 1C1.57554 1 1.23114 1.3444 1.23114 1.76923C1.23114 2.19407 1.57554 2.53846 2.00037 2.53846Z",
    stroke: "#6A7595",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00037 7.76893C2.42521 7.76893 2.7696 7.42453 2.7696 6.9997C2.7696 6.57487 2.42521 6.23047 2.00037 6.23047C1.57554 6.23047 1.23114 6.57487 1.23114 6.9997C1.23114 7.42453 1.57554 7.76893 2.00037 7.76893Z",
    stroke: "#6A7595",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00037 12.9994C2.42521 12.9994 2.7696 12.655 2.7696 12.2302C2.7696 11.8053 2.42521 11.4609 2.00037 11.4609C1.57554 11.4609 1.23114 11.8053 1.23114 12.2302C1.23114 12.655 1.57554 12.9994 2.00037 12.9994Z",
    stroke: "#6A7595",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipses);
export default __webpack_public_path__ + "static/media/ellipses.cf659ddbe888f800ed9b3f1a4fe81e34.svg";
export { ForwardRef as ReactComponent };